import { render, staticRenderFns } from "./product-news.vue?vue&type=template&id=e3fd9558&scoped=true&"
import script from "./product-news.vue?vue&type=script&lang=js&"
export * from "./product-news.vue?vue&type=script&lang=js&"
import style0 from "./product-news.vue?vue&type=style&index=0&id=e3fd9558&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3fd9558",
  null
  
)

export default component.exports